import { useContext } from "react";
import { whatsappTheme } from "./constants";
import CounterMsgContext from "../../pages/shared/CounterMsgContext";

interface WhatsappButtonCounterProps {
  isLoading?: boolean;
}

export const WhatsappButtonCounter = ({
  isLoading = false
}: WhatsappButtonCounterProps) => {
  const { inboxCount } = useContext(CounterMsgContext);

  if (!inboxCount?.countWA && !isLoading) return null;

  return (
    <span
      style={whatsappTheme.badgeStyle}
      aria-live="polite"
      aria-atomic="true"
    >
      {isLoading ? (
        <i className="fas fa-spinner fa-spin" style={{ fontSize: 10 }} />
      ) : inboxCount.countWA > 99 ? (
        "99+"
      ) : (
        inboxCount.countWA
      )}
    </span>
  );
};
